/**
 * services/capabilities/capabilities.ts — builder strategy/motion gating.
 */
import { axiosInstance, unwrap, withFallback } from '../client';
import { Upsell_Capabilities_Url } from '../../api-endpoints/endpoints';
import { Capabilities } from '../../schema/capability';
import { Seed } from '../_demo/seed';

export function getCapabilities(): Promise<Capabilities> {
  return withFallback(
    async () => {
      const { data } = await axiosInstance.get(Upsell_Capabilities_Url);
      return unwrap<Capabilities>(data);
    },
    () => Seed.capabilities(),
  );
}
